module.exports = __webpack_public_path__ + "moon.09333274.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/Moon/moon.png
// module id = 625
// module chunks = 0